<form nz-form [formGroup]="form">
    <nz-table formArrayName="details" [nzData]="data" [nzFrontPagination]="false" [nzShowPagination]="false"
      nzBordered="true" nzSize="small" style="overflow-x: auto; max-height: 355px;">
      <thead>
        <tr>
          <th nzWidth="120px" [nzAlign]="'center'">
            WVat Code
          </th>
          <th nzWidth="120px" [nzAlign]="'right'">
            Payment Amount
          </th>
          <th nzWidth="120px" [nzAlign]="'right'">
            WVat
          </th>
          <th nzWidth="100px">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of details.controls; let i = index" [formGroupName]="i">
          <td>
            <app-wtax-code-select formControlName="wVatCode" valueField="" [borderless]="true" [wvatOnly]="true" [activeOnly]="true">
            </app-wtax-code-select>
          </td>
          <td class="text-right">
            <app-currency-input formControlName="paymentAmount" [ignoreZero]="true" [borderless]="true">
            </app-currency-input>
          </td>
          <td class="text-right">
            {{$any(line.value.wVatAmount)|price}}
          </td>
          <td acl="country.PH" class="text-right">
            <div class="text-center">
              <button type="button" nz-button nzType="text" (click)="removeLine(i)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan="4">
            <button type="button" nz-button [nzType]="'dashed'" (click)="addLine()" nzBlock class="mt-md">
              <i nz-icon nzType="plus"></i>
              <span>New Line</span>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
</form>
  